import { contactsApi } from '../api/contactsApi';
import type { MyRegisterAddressDeleteContext } from '@/features/register/MY/utils/persistMyRegisterContactAddresses';

export type MyCorporateBranchAddressLists = {
    residentialAddressList: any[];
    serviceAddressList: any[];
    businessAddressList: any[];
};

export type MyAddressDeletePersistContext = {
    registerAddressDeleteContext?: MyRegisterAddressDeleteContext | null;
    contactCd?: string;
    useBranchAddresses?: boolean;
    contactListFlatAddressMode?: boolean;
    row?: Record<string, unknown> | null;
};

/** L_CONTACT_BRANCH.BRANCH_ID 또는 L_CONTACT_ADDRESS.ADDRESS_ID */
export function rowHasPersistedBranchId(row: Record<string, unknown> | null | undefined): boolean {
    if (!row || typeof row !== 'object') return false;
    const ids = [
        row.branch_id,
        row.BRANCH_ID,
        row.address_id,
        row.ADDRESS_ID,
        row.addressId,
    ];
    for (const id of ids) {
        const n = Number(id);
        if (Number.isFinite(n) && n > 0) return true;
    }
    return false;
}

/** Confirm 후 서버 즉시 저장 여부 */
export function shouldPersistMyAddressDelete(ctx: MyAddressDeletePersistContext): boolean {
    if (ctx.registerAddressDeleteContext) return true;
    if (ctx.row && (ctx.row as { _isNewDraftRow?: boolean })._isNewDraftRow === true) {
        return false;
    }
    const cd = String(ctx.contactCd || '').trim();
    if (!cd) return false;
    if (ctx.useBranchAddresses || ctx.contactListFlatAddressMode) return true;
    return rowHasPersistedBranchId(ctx.row);
}

function cloneList(rows: any[] | undefined | null): any[] {
    return (Array.isArray(rows) ? rows : []).map((r) => ({ ...(r || {}) }));
}

/** MY Contact — branch(L_CONTACT_BRANCH) 또는 flat(L_CONTACT_ADDRESS) 즉시 저장 */
export async function persistMyCorporateBranchAddresses(
    contactCd: string,
    lists: MyCorporateBranchAddressLists,
    options?: { contactListFlatAddressMode?: boolean },
) {
    const id = String(contactCd || '').trim();
    if (!id) {
        throw new Error('contactCd is required');
    }

    const flat = !!options?.contactListFlatAddressMode;
    return contactsApi.updateContact(id, {
        ...(flat
            ? {
                  saveContactListFlatAddressList: true,
                  skipResidentialJsonDataWrite: true,
                  skipContactListAddressSave: true,
              }
            : {
                  useBranchAddresses: true,
                  skipResidentialJsonDataWrite: true,
              }),
        residentialAddressList: cloneList(lists.residentialAddressList),
        serviceAddressList: cloneList(lists.serviceAddressList),
        businessAddressList: cloneList(lists.businessAddressList),
    } as any);
}
